<div class="flex-row aic m10">
    <span>{{ connectionStatus }}</span>
    <div class="flex-item"></div>
    <button class="btn btn-default" (click)="toggleConnection()" [disabled]="isConnecting">
        {{ getConnectionButtonText() }}
    </button>
</div>

@if (showMessages) {
    @if (messages.length > 0) {
        <div class="message-list view-container m5">
            <div class="view-scroll">
                @for (message of messages | slice: -10; track message) {
                    <div class="flex-row m5" [title]="getFullMessageTooltip(message)">
                        <span class="mr10">{{ message.timestamp | date: 'HH:mm:ss' }}</span>
                        <span class="mr10">{{ getMessageName(message) }}</span
                        >:
                        <span>{{ getMessagePayload(message) }}</span>
                    </div>
                }
            </div>
        </div>
    }
    @if (messages.length > 0) {
        <div class="link" (click)="clearMessages()" onkeypress="">Clear</div>
    }
    @if (messages.length === 0) {
        <div class="m10">No messages yet</div>
    }
}
